import { useTranslation } from 'react-i18next';

import { NavItem } from 'src/components/Buttons/NavItem';
import { MessageSquare } from 'lucide-react';
import { getPrimaryRole, UserRole } from 'src/domain/user';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';

const allowedRoles = new Set([
    UserRole.creator,
    UserRole.organization,
    UserRole.organizationB2C,
]);

export const LinkToMessages = () => {
    const user = useSignedInUser();
    const role = getPrimaryRole(user);
    const { t } = useTranslation();

    if (!role || !allowedRoles.has(role)) {
        return null;
    }

    return (
        <NavItem
            icon={MessageSquare}
            label={t('modules.messages.navLabel')}
            screen="/app/messages"
            indentChildren={false}
        />
    );
};
